import { defineMessages } from 'react-intl';

const scope = 'app.workspace.projects';

export default defineMessages({
  content: {
    id: `${scope}.content`,
    defaultMessage: 'Content',
  },
  course: {
    id: `${scope}.course`,
    defaultMessage: 'Course',
  },
  lesson: {
    id: `${scope}.lesson`,
    defaultMessage: 'Lesson',
  },
  import: {
    id: `${scope}.import`,
    defaultMessage: 'Import',
  },
  eText: {
    id: `${scope}.eText`,
    defaultMessage: 'eText',
  },
});
